module.exports = __webpack_public_path__ + "static/img/P1.def867e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simba/P1.png
// module id = WhBm
// module chunks = 0